const base = {
	black: "#000",
	white: "#fff",
};

const messages = {
	success: "#e6430a",
	error: "#63b893",
	warning: "#ffd943",
};

const withrow = {
	turquoise: "#2bc2b9",
	turquoiseLight: "#2bc2b9c4",
};

const grey = {
	grey: "#e6e6e6",
	greyBorder: "#e6e6e6"
}

const Colors = {
	base,
	messages,
	withrow,
	grey
};

export default Colors;
